var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-text d-flex justify-center"},_vm._l((_vm.textArray),function(char,index){return _c('div',{key:index,style:({ animationDelay: ((index * 0.1) + "s") })},[_vm._v(" "+_vm._s(char)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }